import React from 'react';

/** 仅提供列表区外层背景容器（Shopify 站自带 header/footer，此处不做） */
export default function OrdersChrome({ children, className, dir }) {
  const classes = className ? `orders-layout-app ${className}` : 'orders-layout-app';
  return (
    <div className={classes} dir={dir}>
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/OrdersChrome.jsx